import {map} from 'rxjs/operators/map';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {ApiService, LOCALE_CONFIG} from '@common-lib';

@Injectable()
export class ConfigurationService {

    constructor(private api: ApiService, private http: HttpClient) {}

    getList(resource, localeName) {
        return this.api.get(`/admin/${resource}/${localeName}`);
    }

    createItem(resource, item, localeName) {
        return this.api.post(`/admin/${resource}/${localeName}`, item);
    }

    updateItem(resource, item, localeName) {
        return this.api.put(`/admin/${resource}/${item.id}/${localeName}`, item);
    }

    delete(resource, ids) {
        return this.api.delete(`/admin/${resource}/${ids}`);
    }

    getExport(products: string[], showPrice?: boolean, localeName: string = LOCALE_CONFIG.DEFAULT_LOCALE) {
        return this.api.post(`/admin/export-configuration/${localeName}`, {
            products,
            showPrice
        }).pipe(map(response => response));
    }

    uploadImport(file) {
        return this.api.post('/admin/import-configuration', file).pipe(map(response => response));
    }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/configuration.service.ts